// Mục đích xuất cho xuất kho
export default {
  OutwardUsed: 0, // 'Xuất dùng',
  OutwardOther: 2, // 'Xuất khác',
};
